// src/pages/AttendanceOverview/components/PendingRequestsList.js
import React from "react";
import { Card, List, Empty, Tag, Button, Popconfirm, message } from "antd";

import { useDispatch, useSelector } from "react-redux";
import { selectPendingRequests } from "../attendanceOverviewSelectors";
import {
  monthWiseForamatedDate,
  formatTitleCaseLabel,
} from "../../../lib/functions";
import {
  updateAttendanceStatus,
  fetchCalendar,
  fetchPendingRequests,
} from "../attendanceOverviewThunk";

const PendingRequestsList = () => {
  const dispatch = useDispatch();
  const pending = useSelector(selectPendingRequests) || {
    pending: [],
    attendance: [],
  };

  // const dates = pending.pending || [];

  const pendingRequests = pending.pending || [];

  // Separate into leave & attendance types
  const leaveDays = [];
  const attendanceDays = [];
  const regularizationDays = [];
  

  pendingRequests.forEach((item) => {
    // Regularization requests
    if (item.is_regularized === 1 || item.is_regularized === "1") {
      regularizationDays.push(item);
      return;
    }
    switch (item.attendance) {
      case "sick_leave":
      case "casual_leave":
      case "leave_with_pay":
      case "short_leave":
      case "short_casual_leave":
      case "short_sick_leave":
      case "annual_leave":
      case "leave_without_pay":
      case "compensatory_leave":
      case "maternity_leave":
        leaveDays.push(item);
        break;
      case "present":
        attendanceDays.push(item);
        break;
      default:
        break;
    }
  });

  const handleCancel = async (item) => {
    try {
      const payload = {
        user_id: item.user_id,
        status: "cancelled",
        fromDate: item.attendance_date,
        toDate: item.attendance_date,
      };
      await dispatch(updateAttendanceStatus(payload)).unwrap();
      message.success("Request cancelled successfully");
      await Promise.all([
        dispatch(fetchPendingRequests()).unwrap(),
        dispatch(fetchCalendar()).unwrap(),
      ]);
    } catch {
      message.error("Failed to cancel request");
    }
  };

  const render = (item) => (
    <List.Item
      actions={[
        <Popconfirm
          key="cancel"
          title="Cancel this request?"
          okText="Yes"
          cancelText="No"
          onConfirm={() => handleCancel(item)}
        >
          <Button type="link" danger>
            Cancel
          </Button>
        </Popconfirm>,
      ]}
    >
      <List.Item.Meta
        title={monthWiseForamatedDate(item.attendance_date)}
        description={
          <>
            <div>
              {item.attendance ? (
                <Tag>{formatTitleCaseLabel(item.attendance)}</Tag>
              ) : null}
              <span style={{ marginLeft: 8 }}>{item.notes}</span>
            </div>
          </>
        }
      />
    </List.Item>
  );
  return (
    <Card title="View Pending request" style={{ marginTop: 16 }}>
      <div style={{ marginBottom: 12, fontWeight: 600 }}>Pending Leave Requests</div>
      <List
        dataSource={leaveDays}
        renderItem={render}
        locale={{
          emptyText: <Empty description="No pending leave requests" />
        }}
      />

      <div style={{ marginTop: 18, marginBottom: 12, fontWeight: 600 }}>
        Pending Attendance Requests
      </div>
      <List
        dataSource={attendanceDays}
        renderItem={render}
        locale={{
          emptyText: <Empty description="No pending attendance requests" />
        }}
      />

      <div style={{ marginTop: 18, marginBottom: 12, fontWeight: 600 }}>
        Pending Attendance Regularizations
      </div>

      <List
        dataSource={regularizationDays}
        renderItem={render}
        locale={{
          emptyText: (
            <Empty description="No pending attendance regularizations" />
          ),
        }}
      />
    </Card>
  );
};

export default PendingRequestsList;
